import { render, staticRenderFns } from "./shopCreateFeeList.vue?vue&type=template&id=3108397e&scoped=true"
import script from "./shopCreateFeeList.vue?vue&type=script&lang=js"
export * from "./shopCreateFeeList.vue?vue&type=script&lang=js"
import style0 from "./shopCreateFeeList.vue?vue&type=style&index=0&id=3108397e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3108397e",
  null
  
)

export default component.exports